(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuButton = document.querySelector('.mobile-menu-button');
    const mobileMenuDrawer = document.querySelector('.mobile-menu-drawer');
    const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');

    function openMenu() {
      mobileMenuDrawer.classList.add('is-open');
      mobileMenuOverlay.classList.add('is-open');
    }

    function closeMenu() {
      mobileMenuDrawer.classList.remove('is-open');
      mobileMenuOverlay.classList.remove('is-open');
    }

    if (mobileMenuButton) {
      mobileMenuButton.addEventListener('click', openMenu);
    }

    if (mobileMenuOverlay) {
      mobileMenuOverlay.addEventListener('click', closeMenu);
    }

// Close menu when a link is clicked
    const drawerLinks = document.querySelectorAll('.mobile-menu-drawer .menu-link');
    drawerLinks.forEach(link => {
      link.addEventListener('click', function(e) {

// No prevenir el comportamiento por defecto, solo cerrar el menú
        closeMenu();
      });
    });

// Calcular y establecer la altura del header como variable CSS
    function setHeaderHeight() {
      const header = document.querySelector('.header-wrapper');
      const headerHeight = header.offsetHeight;

// Establecer la variable CSS para la altura del header
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

// Actualizar el padding-top del body para compensar el header
      document.body.style.paddingTop = `${headerHeight}px`;

// Asegurar que el logo esté centrado verticalmente
      const logoWrapper = document.querySelector('.header__heading-logo-wrapper');
      if (logoWrapper) {
        logoWrapper.style.lineHeight = `${headerHeight}px`;
      }
    }

// Inicializar alturas
    setHeaderHeight();

// Añadir evento de scroll
    window.addEventListener('scroll', function() {
      const headerWrapper = document.querySelector('.header-wrapper');
      if (window.scrollY > 0) {
        headerWrapper.classList.add('scrolled');
      } else {
        headerWrapper.classList.remove('scrolled');
      }
    });

// Actualizar alturas al cambiar el tamaño de la ventana
    window.addEventListener('resize', function() {
      setHeaderHeight();
    });

// Volver a calcular después de que las imágenes carguen
    window.addEventListener('load', function() {
      setHeaderHeight();
    });

// Update cart count
    function updateCartCount() {
      fetch('/cart.js').then(response => response.json()).then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      }).catch(error => console.error('Error fetching cart:', error));
    }

// Initial cart count update
    updateCartCount();

// Listen for cart changes
    document.addEventListener('cart:updated', function(event) {
      updateCartCount();
    });

// Update cart count when items are added to cart
    document.addEventListener('product:added', function(event) {
      updateCartCount();
    });

// Also check periodically
    setInterval(updateCartCount, 5000);
  });

  document.addEventListener('DOMContentLoaded', function() {

// Manejar el enlace del header que siempre debe ir a home
    const headerShopLinks = document.querySelectorAll('a[href="https://www.followyournez.com/#shop-all-section"], a[href="/#shop-all-section"]');

    if (headerShopLinks.length > 0) {
      headerShopLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();

// Siempre ir a home, sin importar en qué página estemos
          if (window.location.pathname === '/') { // Si ya estamos en home, solo scroll
            const target = document.getElementById('shop-all-section');
            if (target) {
              target.scrollIntoView({behavior: 'smooth'});
            }
          } else { // Si estamos en cualquier otra página, ir a home
            window.location.href = 'https://www.followyournez.com/#shop-all-section';
          }
        });
      });
    }
  });


  } catch(e) { console.error(e); }
})();
})();
